import { render, staticRenderFns } from "./IframePopup.vue?vue&type=template&id=604c165c"
import script from "./IframePopup.vue?vue&type=script&lang=js"
export * from "./IframePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports